import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const RoleRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  roleList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getRole}`, {
    params: {
     
      search: values?.search
    }
  }),
  // deleteCategory: (id) => api.post(`${API_URL.BASEURL}${API_URL.deleteCategory}`, id),
  updateRole: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateRole}`, values),
  roleDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.roleDetail}?roleId=${id}`),
  createRole: (values) => api.post(`${API_URL.BASEURL}${API_URL.createRole}`, values),
  createPermissionRole: (values) => api.post(`${API_URL.BASEURL}${API_URL.createPermissionRole}`, values),
  getModule: () => api.get(`${API_URL.BASEURL}${API_URL.moduleDetails}`),
  // getServiceByCategory: (id) => api.get(`${API_URL.BASEURL}${API_URL.getServiceByCategory}?categoryId=${id}`),
  // updateService: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateServices}`, values),
  // createService: (values) => api.post(`${API_URL.BASEURL}${API_URL.createServices}`, values),
  // serviceDetails: (id) => api.get(`${API_URL.BASEURL}${API_URL.serviceDetail}?id=${id}`),

  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=category`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default RoleRequest